module.exports = __webpack_public_path__ + "img/s00168.4e954ca2.png";